import React from 'react';
import UpVioletImg from '../../assets/images/up-violet.svg';
import UpLoadingBar from '../../components/Common/UpLoadingBar';
import StepIndicator from './StepIndicator';

function AppPage({ step, loading = false, wide = false, children }) {
  return (
    <div className="signup-page">
      <div className="signup-topbar">
        <img src={UpVioletImg} alt="UrbanPiper" />
      </div>
      <UpLoadingBar loading={loading} />
      <div className="signup-body">
        <div className={wide ? 'signup-card card-wide' : 'signup-card'}>
          {step && <StepIndicator current={step} />}
          {children}
        </div>
      </div>
    </div>
  );
}

export default AppPage;
